// Tapelligence Demo Mode — client transport of the signed demo token ONLY.
// The browser cannot (and must not) verify the token; the backend does. Here we
// just capture ?demo_token=<jwt> from an authorized demo link, cache it per
// card, and immediately scrub it from the visible URL so it isn't leaked via
// history/referrer/copied links. All PIN behavior is still decided server-side.
const QUERY_KEY = 'demo_token';
const STORAGE_PREFIX = 'yulontap_demo:';

export function captureDemoToken(cardId) {
    try {
        const params = new URLSearchParams(window.location.search);
        const token = params.get(QUERY_KEY);
        if (token && token.length <= 4096) {
            localStorage.setItem(STORAGE_PREFIX + cardId, token);
            params.delete(QUERY_KEY);
            const q = params.toString();
            const clean = window.location.pathname + (q ? `?${q}` : '') + window.location.hash;
            window.history.replaceState({}, document.title, clean);
            return token;
        }
        return localStorage.getItem(STORAGE_PREFIX + cardId);
    } catch {
        return null;
    }
}

export function getDemoToken(cardId) {
    try {
        return localStorage.getItem(STORAGE_PREFIX + cardId);
    } catch {
        return null;
    }
}

export function clearDemoToken(cardId) {
    try {
        localStorage.removeItem(STORAGE_PREFIX + cardId);
    } catch { /* private mode */ }
}
